import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { useCallback } from "react";
import { authQueryKey } from "../auth.queries";

type UseAuthSuccessHandlerOptions = {
  onAuthenticated?: (() => void) | undefined;
  redirectTo: string;
};

export function useAuthSuccessHandler({
  onAuthenticated,
  redirectTo,
}: UseAuthSuccessHandlerOptions) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const router = useRouter();

  return useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: authQueryKey });

    if (onAuthenticated) {
      if (typeof router.invalidate === "function") {
        await router.invalidate();
      }
      onAuthenticated();
      return;
    }

    await navigate({ to: redirectTo, replace: true });
  }, [navigate, onAuthenticated, queryClient, redirectTo, router]);
}
